import { onScrollEvent } from '../02-core/scrollManager';
// import setupScrollListener from '../02-core/scrollListener';

/**
 * Hides the header on scroll down, shows on scroll up.
 */
export default function setupHeaderScrollBehavior() {
    const slopesHeader = document.getElementById('is-slopes-page');
    if (!slopesHeader) return; // Exit if not in slopes header
    // const header = document.getElementById('cl-ctn-header-with-searcher');
    // const navbar = document.getElementById('cl_estiber_style');
    const header = slopesHeader.querySelector('#cl-ctn-header-with-searcher');
    const navbar = slopesHeader.querySelector('#cl_estiber_style');
    if (!navbar || !header) return;

    const threshold = 300; // px from the top

    // Apply transition for smooth movement
    header.style.transition = 'transform 0.3s ease';
    // setupScrollListener(({ direction }) => {
    onScrollEvent(({ direction, position }) => {

        const headerHeight = header.offsetHeight;
        const navbarHeight = navbar.offsetHeight;
        const heightOffset = 1;
        console.log([headerHeight, heightOffset, headerHeight + heightOffset])
        if (direction === 'down') {
            header.style.transform = `translateY(-${headerHeight}px)`;
        } else if (direction === 'up') {
            if (position < threshold) {
                // Show full header only if scrolled to top
                header.style.transform = 'translateY(0)';
            } else {
                // Show header without navbar if below threshold
                header.style.transform = `translateY(-${navbarHeight + heightOffset}px)`;
            }
        }
    }, 0); // No throttle for immediate response
}
